// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1xRkz","info":"PatientInfo_info__1OBNO"};